import { render, staticRenderFns } from "./buy-subscription.vue?vue&type=template&id=467262be&"
import script from "./buy-subscription.vue?vue&type=script&lang=js&"
export * from "./buy-subscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports